import * as React from "react"
import {phrases} from "./phrases_common"

let locale: string | undefined = process.env.LANG
let localeIndex:number | null = null

function supplant(message, variables, fallback : string | number | null = null, formatter: Function | null = null) {
    if(typeof message !== "string") {
        try {
            throw new Error('Message is not string');
        }
        catch (e) {
            console.error(e);
        }
        return ""
    }
    return message.replace(/{([^{}]*)}/g,
        function (a, b) {
            if(variables[b] !== undefined) {
                if(formatter !== null) {
                    return formatter && formatter(variables[b])
                }
                return variables[b]
            }
            if(fallback !== null) {
                return fallback
            }
            return '{?}'
        }
    );
}

function getLocaleIndex(locale) {
    switch (locale) {
        case "cz":
            return 0
        case "sk":
            return 1
        default:
            return 0
    }
}

const trans_cache: any = {}


export function tr(trans, key, variables: any = null, formatter = null, multilang = false) {
    if(!key) {
        return ""
    }

    if(trans_cache[key] !== undefined && variables === null) {
        return trans_cache[key]
    }

    let message: any = key
    if(trans[key]) {
        if(multilang === false) {
            message = trans[key]
        } else {
            if(locale === null) {
                locale = "cz"
            }
            if(localeIndex === null) {
                localeIndex = getLocaleIndex(locale)
            }
            message = trans[key][localeIndex]
        }
    }

    // if(message === key) {
    //     try {
    //         throw new Error('Missing translation: ' + key);
    //     }
    //     catch (e) {
    //         console.error(e);
    //     }
    // }

    if(variables && message && message.count) {
        message.count.some((m,n) => {
            try {
                if(m.if && eval(m.if.replace(/{n}/g,variables.n))) {
                    message = supplant(m.then, variables, 0, formatter)
                    return true
                }
                if(m.else) {
                    message = supplant(m.else, variables, 0, formatter)
                    return true
                }
            } catch(e) {
                console.log(key,m.if,variables)
            }
            return null
        })
    } else
    if(variables && message && message.string) {
        message.string.some((m,n) => {

            if(Object.keys(variables).length > 0 && m.if) {
                let ret = false
                Object.keys(variables).forEach(variable => {
                    if(eval(m.if.replace('{'+variable+'}',variables[variable]))) {
                        message = supplant(m.then, variables, "", formatter)
                        ret = true
                    }
                })
                if(ret) {
                    return true
                }
            }
            if(m.else) {
                message = supplant(m.else, variables, "",formatter)
                return true
            }
            return null
        })
    } else
    if (variables !== null && message) {
       if(message.indexOf('{{') > -1 && message.indexOf('}}') > -1) {
            const matches = message.matchAll(RegExp('{{(.*?)}}','g'))
            const ret:any[] = []
            let start = 0
            let end = 0

            for (const match of matches) {
                end = match.index
                ret.push(message.substring(start, end))
                start = match.index + match[0].length
                const variable = match[0].replace('{{','').replace('}}','')
                ret.push(variables[variable])
            }
            ret.push(message.substring(start))

            return ret
        } else {
            message = supplant(message, variables, null, formatter);
        }
    }

    if(typeof message !== "string" || message === "") {
        return key
    }

    if(message.indexOf('</') > -1 || message.indexOf('/>') > -1) {
        return <span dangerouslySetInnerHTML={{ __html: message }} />
    }
    // if(variables === null) {
    //     trans_cache[key] = message
    // }
    return message
}



export const trans = (key: string, variables: any = null, formatter = null) => tr(phrases.messages, key, variables, formatter, true)

export const isTrans = (key) => {
    return phrases && phrases[key] !== undefined
}

export default trans